export const isImage = (mimeType: string): boolean => {
  return mimeType.trim().toLowerCase().startsWith("image/");
};
